import axios from 'axios';

// Public API client — no JWT token interceptor
// Used for public pages (apply, survey) that don't require authentication
const publicClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  headers: { 'Content-Type': 'application/json' },
});

export default publicClient;
